import { render, staticRenderFns } from "./NewDownline.vue?vue&type=template&id=9961f806&scoped=true&"
import script from "./NewDownline.vue?vue&type=script&lang=ts&"
export * from "./NewDownline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9961f806",
  null
  
)

export default component.exports